<template>
    <div class="my-8 dm-manuscript-illustration-thumbs-wizard">
        <SingleIllustration
            v-for="illustration in presentation.illustrations"
            :key="'illustration-' + illustration.name"
            :illustration="illustration"
        />
    </div>
</template>

<script>
import SingleIllustration from "./SingleIllustration.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { SingleIllustration },

    computed: {
        ...mapState(useSubmissionWizardStore, ["presentation"]),
    },
};
</script>
